// extracted by mini-css-extract-plugin
export default {"amountRepaid":"PastRepayments_amountRepaid","link":"PastRepayments_link","chevron":"PastRepayments_chevron"};